module.exports = __webpack_public_path__ + "static/media/v39.4aff9341.mp4";